export enum SecurityModals {
  failed,
  error,
  sending,

  answerSecurityQuestions,
  // pinResetSendOtp,
  // passwordResetSendOtp,
  enterPin,
  changePass,
  changePin,
  viewSecurityQuestions,
  successPin,
  successPass,
  successSecQuestion,
  sendingOtp,
  otpVerify,
}

export interface SecurityQuestion {
  securityQuestionId: number;
  Question: string;
}

export interface UserSecurityQuestion {
  Id: 0;
  CreatedBy: "string";
  CreatedOn: "2024-06-11T12:51:27.801Z";
  UpdatedBy: "string";
  UpdatedOn: "2024-06-11T12:51:27.801Z";
  ApprovedBy: "string";
  ApprovedOn: "2024-06-11T12:51:27.801Z";
  Question: "string";
}

export enum SubmitCorporateDocumentModal {
  success,
  failed,
  pending,
}